module.exports = __webpack_public_path__ + "static/img/img_2541.7c4ad09.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/img_2541.jpg
// module id = a7hV
// module chunks = 0